import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { forwardRef } from 'react';
import { Icon, Text } from '../../index';
import { SPINNER_BADGE_DEFAULT_ICON_LOADING_TITLE } from './SpinnerBadge.constants';
import { SpinnerBadgeRoot } from './SpinnerBadge.styled';
// Component.
// -----------------------------------------------------------------------------
const SpinnerBadge = forwardRef(({ label, mode = 'light', ...rest }, ref) => (_jsxs(SpinnerBadgeRoot, { ref: ref, mode: mode, ...rest, children: [_jsx(Icon, { className: "spinner-badge__icon--loading", icon: faSpinnerThird, size: "l", spin: true, title: SPINNER_BADGE_DEFAULT_ICON_LOADING_TITLE }), label && (_jsx(Text, { size: "xs", bold: true, children: label }))] })));
// Component configuration.
// -----------------------------------------------------------------------------
SpinnerBadge.displayName = 'SpinnerBadge';
export default SpinnerBadge;
//# sourceMappingURL=SpinnerBadge.js.map